export default __webpack_public_path__ + "static/droppingMeats-45ed26bf4ad347457b674a384096eca1.svg";